/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import useStore from "../../store";
import PTMDialog from "../PTMDialog";
import PTMInput from "../PTMInput";
import BoilerplateDisplayerEntry from "./BoilerplateDisplayerEntry";

function BoilerplateDisplayer(props) {
    const {
        tabId,
        onClose,
        insertBoilerplate,
    } = props;

    const [searchKey, setSearchKey] = useState("");

    const boilerplates = useStore((store) => store.app.boilerplates);

    const dialogRef = useRef(null);

    const search = (e) => {
        setSearchKey(e.target.value);
    };

    const filterBoilerplates = () => {
        if (searchKey === "") return boilerplates;
        return boilerplates.filter((b) => b?.description?.toLowerCase().includes(searchKey.toLowerCase()));
    };

    const insertBoilerplateHandler = (value) => {
        insertBoilerplate(value);
        onClose();
        setTimeout(() => {
            dialogRef.current.focus();
        }, 0);
    };

    return (
        <PTMDialog
            open
            tabId={tabId}
            everywhereVisible={!tabId}
            onClose={onClose}
            style={{ height: "100%" }}
            fixedWidth="800px"
            containerId={`tab-${tabId}-container`}
            dialogWrapperStyle={{ height: "100%" }}
            dialogContentStyle={{
                width: "100%",
                padding: "5px !important",
            }}
            disableBackdrop
            title="Textbaustein hinzufügen"
            footerButtons={
                [{
                    name: "Abbrechen",
                    click: onClose,
                    color: "error",
                    icon: "times",
                }]
            }
            wrapperRef={dialogRef}
        >
            <PTMInput
                noForm
                fullWidth
                placeholder="Suchen"
                defaultValue=""
                onChange={search}
            />
            <div style={{ marginTop: "10px" }}>
                {filterBoilerplates(boilerplates).map((boilerplate) => (
                    <BoilerplateDisplayerEntry
                        insertHandler={insertBoilerplateHandler}
                        content={boilerplate.content}
                        description={boilerplate.description}
                    />
                ))}
            </div>
        </PTMDialog>
    );
}

export default BoilerplateDisplayer;
